import React, { useEffect, useRef } from "react";
import { trpc } from "@/lib/trpc";
import { createConversionAttribution, initializeConversionAttribution } from "@/lib/attribution";
import { trackGa4PhoneClick } from "@/lib/ga4";

export function ConversionTracker() {
  const phoneClick = trpc.conversions.trackPhoneClick.useMutation();
  const mutateRef = useRef(phoneClick.mutate);
  mutateRef.current = phoneClick.mutate;

  useEffect(() => {
    initializeConversionAttribution();
    const trackTelephoneClick = (event: MouseEvent) => {
      const target = event.target instanceof Element ? event.target.closest<HTMLAnchorElement>('a[href^="tel:"]') : null;
      if (!target) return;
      trackGa4PhoneClick();
      mutateRef.current(createConversionAttribution(window.location.pathname), {
        onError: () => undefined,
      });
    };
    document.addEventListener("click", trackTelephoneClick, true);
    return () => document.removeEventListener("click", trackTelephoneClick, true);
  }, []);

  return null;
}
